import { useContext, useMemo } from "react"
import { useSelector } from "react-redux"
import { HeaderContext } from "../HeaderContext"
import { getAffiliationLabel } from "pages/School/Affiliations/hooks/getAffiliationLabel"


const useAdvancedFilters = () => {
    const { affiliations } = useContext(HeaderContext)
    const { grades } = useSelector(state => state.testTaker)
    const { brokenDisplay } = useSelector(state => state.general)

    const advancedFilters = useMemo(() => [
        {
            id: 3,
            placeholder: "שם הבית ספר",
            options: affiliations.data,
            name: "home_affiliation",
            getTooltip: brokenDisplay ? null : (opt) => getAffiliationLabel(opt),
            component: "autoComplete",
            width: 220,
            showBlurred: !!brokenDisplay,
            fullWidth: true,
        },
        {
            id: 4,
            placeholder: "שכבה",
            name: "home_grade",
            component: "autoComplete",
            width: 130,
            options: grades,
            fullWidth: true
        },
    ], [brokenDisplay, grades, affiliations])

    return advancedFilters
}

export default useAdvancedFilters